// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34fU5","left":"styles_left__3SHJ9","right":"styles_right__-TfO8","alert":"styles_alert__2YZ5V"};